import React, { Component } from 'react';
import { Table, Segment } from 'semantic-ui-react'

import find from 'lodash/find'

import constants from '../../constants';

const _ = { find }

const breakdownOfFees = constants.breakdownOfFees;
const tuitionFeeSched = constants.tuitionFeeSched;

export class Success extends Component {
  continue = e => {
    e.preventDefault();
    // PROCESS FORM //
    this.props.nextStep();
  };

  back = e => {
    e.preventDefault();
    this.props.prevStep();
  };

  render() {
    const { values } = this.props;
    let breakdownLevel, scheduleOfPayment, ue, amt;
    if (values.gradeLevel) {
      breakdownLevel = _.find(breakdownOfFees, {
        gradeLevel: values.gradeLevel
      });
    }

    if (values.paymentSchedule) {
      scheduleOfPayment = _.find(tuitionFeeSched, {
        gradeLevel: values.gradeLevel
      });

      if (values.paymentSchedule === 'Full Cash Basis') {
        ue = scheduleOfPayment.cash;
        amt = '';
      } else if (values.paymentSchedule === 'Semi-Annual'){
        ue = scheduleOfPayment.uponEnrollmentSemi;
        amt = scheduleOfPayment.semi;
      } else if (values.paymentSchedule === 'Quarterly'){
        ue = scheduleOfPayment.uponEnrollmentQuarterly;
        amt = scheduleOfPayment.quarterly;
      } else if (values.paymentSchedule === 'Monthly Basis'){
        ue = scheduleOfPayment.uponEnrollmentMonthlyPlusBooks;
        amt = scheduleOfPayment.monthly;
      } else {
        ue = '';
        amt = '';
      }
    }
    return (
      <Segment className='enrollment-form-segment'>
        <h1>Thank You For Your Submission</h1>
        <h1>Applicant Number: <strong>{this.props.appNumber}</strong></h1>
        <h3>
          {
          `Please remember your applicant number: ${this.props.appNumber}. You can use this to track your application.
          You will get an email with further instructions.`
          }
        </h3>

        <div style={{marginBottom: '14px'}}>
          <span>Breakdown of Fees</span>
          <Table unstackable celled size='small'>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>LEVEL</Table.HeaderCell>
                <Table.HeaderCell>TUITION FEES</Table.HeaderCell>
                <Table.HeaderCell>MISC FEES</Table.HeaderCell>
                <Table.HeaderCell>BOOKS & MAGAZINES</Table.HeaderCell>
                <Table.HeaderCell>TOTAL</Table.HeaderCell>
                <Table.HeaderCell>SUBSIDY</Table.HeaderCell>
                <Table.HeaderCell>TOTAL (TF, MISC, BOOKS)</Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>
              <Table.Row>
                <Table.Cell>{breakdownLevel.gradeLevel}</Table.Cell>
                <Table.Cell textAlign='right'>{breakdownLevel.tuition}</Table.Cell>
                <Table.Cell textAlign='right'>{breakdownLevel.misc}</Table.Cell>
                <Table.Cell textAlign='right'>{breakdownLevel.books}</Table.Cell>
                <Table.Cell textAlign='right'>{breakdownLevel.total}</Table.Cell>
                <Table.Cell textAlign='right' color='green'>{breakdownLevel.subsidy}</Table.Cell>
                <Table.Cell textAlign='right'><strong>{breakdownLevel.grandTotal}</strong></Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </div>

        <div style={{marginBottom: '14px'}}>
          <span>Payment Schedule</span>
          <Table unstackable celled size='small'>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>LEVEL</Table.HeaderCell>
                <Table.HeaderCell>PAYMENT SCHEDULE</Table.HeaderCell>
                <Table.HeaderCell>UPON ENROLLMENT</Table.HeaderCell>
                <Table.HeaderCell>NEXT PAYMENT</Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>
              <Table.Row>
                <Table.Cell>{scheduleOfPayment.gradeLevel}</Table.Cell>
                <Table.Cell textAlign='right'>{values.paymentSchedule}</Table.Cell>
                <Table.Cell textAlign='right'>{ue}</Table.Cell>
                <Table.Cell textAlign='right'>{amt}</Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </div>
      </Segment>
    );
  }
}

export default Success;
